var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseLecIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.323,
    height: 25.323,
    viewBox: "0 0 25.323 25.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_34_",
    "data-name": "svgexport-6 (34)",
    transform: "translate(12.663 25.415) rotate(-135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10283",
    "data-name": "Group 10283",
    transform: "matrix(0.017, 1, -1, 0.017, 17.816, -0.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10282",
    "data-name": "Group 10282",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10281",
    "data-name": "Group 10281",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10603",
    "data-name": "Path 10603",
    d: "M0,3.946a.789.789,0,0,0,.789.789H3.157V7.1a.789.789,0,0,0,1.578,0V4.735H7.1a.789.789,0,0,0,0-1.578H4.735V.789a.789.789,0,0,0-1.578,0V3.157H.789A.789.789,0,0,0,0,3.946Z",
    transform: "translate(5.009 5.009)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10604",
    "data-name": "Path 10604",
    d: "M1.091,1.941l1.021-.423A.789.789,0,1,0,1.508.06L.487.483a.789.789,0,1,0,.6,1.458Z",
    transform: "translate(4.555 0.497)",
    fill: "#dbdfea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10605",
    "data-name": "Path 10605",
    d: "M8.955,0a.7.7,0,1,0,0,1.4A7.555,7.555,0,1,1,1.4,8.955a.7.7,0,1,0-1.4,0A8.955,8.955,0,1,0,8.955,0Z",
    fill: "#dbdfea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10606",
    "data-name": "Path 10606",
    d: "M1.347,2.129l.781-.781A.789.789,0,0,0,1.012.231l-.781.781A.789.789,0,0,0,1.347,2.129Z",
    transform: "translate(2.337 2.337)",
    fill: "#dbdfea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10607",
    "data-name": "Path 10607",
    d: "M.487,2.539a.789.789,0,0,0,1.031-.427l.423-1.021A.789.789,0,0,0,.483.487L.06,1.508A.789.789,0,0,0,.487,2.539Z",
    transform: "translate(0.497 4.555)",
    fill: "#dbdfea"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLecIcon);
export default __webpack_public_path__ + "static/media/close-lec-icon.d522e0fb966a9b9d97050430eb157491.svg";
export { ForwardRef as ReactComponent };